(() => {
  'use strict';
  const configElement = document.getElementById('gl-greece-only-config');
  if (!configElement) return;
  const config = JSON.parse(configElement.textContent);
  const productIds = new Set(config.products.map(p => p.id));
  const variantIds = new Set(config.products.flatMap(p => p.variants));
  const boostControls = '.boost-sd__button--select-option, .boost-sd__button--add-to-cart, .boost-sd__button--quick-view';
  const customControls = '.gl-snippet-add[data-variant-id], [data-stl-add]';
  const notice = container => {
    if (container.querySelector('[data-gl-greece-only-notice]')) return;
    const p = document.createElement('p');
    p.className = 'gl-greece-only-notice';
    p.dataset.glGreeceOnlyNotice = '';
    p.textContent = config.message;
    container.append(p);
  };
  const block = button => {
    if (!button.hasAttribute('data-gl-greece-only-blocked')) button.setAttribute('data-gl-greece-only-blocked', '');
    if (!button.hidden) button.hidden = true;
    if ('disabled' in button && !button.disabled) button.disabled = true;
  };
  const restrictedForm = form => {
    if (!form.getAttribute('action')?.includes('/cart/add')) return false;
    return variantIds.has(String(new FormData(form).get('id')));
  };
  const restrictedCustom = button => {
    if (button.matches('.gl-snippet-add')) return variantIds.has(button.dataset.variantId);
    const card = button.closest('[data-stl-card]');
    return Boolean(card && (variantIds.has(card.dataset.plant) || variantIds.has(card.dataset.pot)));
  };
  const restrictedBoost = button => {
    const card = button.closest('.boost-sd__product-item[data-product-id]');
    return Boolean(card && productIds.has(card.dataset.productId));
  };
  const update = () => {
    document.querySelectorAll('.boost-sd__product-item[data-product-id]').forEach(card => {
      if (!productIds.has(card.dataset.productId)) return;
      card.querySelectorAll(boostControls).forEach(block);
      notice(card.querySelector('.boost-sd__product-info') || card);
    });
    document.querySelectorAll('form[action*="/cart/add"]').forEach(form => {
      if (!restrictedForm(form) || !form.querySelector('[type="submit"], .shopify-payment-button')) return;
      form.querySelectorAll('[type="submit"], .shopify-payment-button').forEach(block);
      notice(form);
    });
    document.querySelectorAll(customControls).forEach(button => {
      if (!restrictedCustom(button)) return;
      block(button);
      notice(button.parentElement);
    });
  };
  document.addEventListener('submit', event => {
    if (!(event.target instanceof HTMLFormElement) || !restrictedForm(event.target)) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    notice(event.target);
  }, true);
  // Capture phase prevents delegated application handlers from submitting first.
  document.addEventListener('click', event => {
    if (!(event.target instanceof Element)) return;
    const button = event.target.closest(boostControls + ', ' + customControls + ', button[type="submit"], input[type="submit"]');
    if (!button) return;
    const denied = (button.matches(boostControls) && restrictedBoost(button)) ||
      (button.matches(customControls) && restrictedCustom(button)) ||
      (button.form && restrictedForm(button.form));
    if (!denied) return;
    event.preventDefault();
    event.stopImmediatePropagation();
    block(button);
  }, true);
  let scheduled = false;
  const schedule = () => {
    if (scheduled) return;
    scheduled = true;
    requestAnimationFrame(() => { scheduled = false; update(); });
  };
  new MutationObserver(schedule).observe(document.body, {
    childList:true, subtree:true, attributes:true,
    attributeFilter:['data-product-id','data-variant-id','data-plant','data-pot','value','disabled','hidden']
  });
  document.addEventListener('change', schedule, true);
  update();
})();
